import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioDetalharComponent } from './usuario-detalhar.component';




@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: UsuarioDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class UsuarioDetalharRoutingModule { }
